import { motion } from "framer-motion";
import { Play } from "lucide-react";
import FitPulseLogo from "./FitPulseLogo";

const FinalCTA = () => {
  return (
    <section
      data-testid="final-cta-section"
      className="bg-[#0D0D0D] py-24 sm:py-32 lg:py-40"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.5 }}
          className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-4"
        >
          Start tracking today. It's free.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="text-base sm:text-lg text-[#888] mb-10"
        >
          No subscription. No credit card. Just download and go.
        </motion.p>

        <motion.a
          data-testid="final-cta-download-button"
          href="https://play.google.com/store"
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.5, delay: 0.2 }}
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          className="inline-flex items-center gap-2.5 bg-white text-[#0D0D0D] font-semibold px-8 py-4 rounded-full text-sm sm:text-base"
        >
          <Play size={18} fill="#0D0D0D" />
          Download on Google Play
        </motion.a>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="flex items-center justify-center gap-2.5 mt-8"
        >
          <FitPulseLogo size={20} color="#333" />
          <span className="text-xs text-[#666]">FitPulse by Zevora Labs</span>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
